"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioDot = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _v = require("./tokens/v2");

var _v2 = require("./tokens/v3");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RadioDot = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "RadioDot",
  componentId: "sc-1m6kyb-0"
})(["width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background-color 0.25s,border-color 0.25s,color 0.25s;", ";&::after{content:\"\";display:block;width:10px;height:10px;border-radius:50%;transition:background-color 0.25s;background-color:currentColor;}"], function (props) {
  var modes = (0, _Theme.getThemeConfig)(props, {
    v2: _v.RADIO_DOT_STATES,
    v3: _v2.RADIO_DOT_STATES
  });

  var mode = function () {
    switch (true) {
      case props.disabled:
        return modes.disabled;

      case props.hover:
        return modes.hover;

      case props.error:
        return modes.error;

      default:
        return modes.default;
    }
  }();

  return props.selected ? mode.selected : mode.resting;
});
exports.RadioDot = RadioDot;